import { CmsPageEditContext } from '../../contexts/cms/cmsPageEdit/CmsPageEditContextProvider';
import { useContext } from 'react';

const useCmsPageEditContext = () => {
  return useContext(CmsPageEditContext);
};

export default useCmsPageEditContext;
